import { useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';

/**
 * ToasterThemeSync Component
 * 
 * This component syncs Sonner toast theme with the app's dark mode setting.
 * It listens to theme changes and updates Sonner's theme dynamically.
 */
const ToasterThemeSync = () => {
  const { darkMode } = useTheme();

  useEffect(() => {
    // Update Sonner theme
    const toasterElement = document.querySelector('[data-sonner-toaster]');
    if (toasterElement) {
      toasterElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    }

    // Update CSS custom properties for toast styling
    document.documentElement.style.setProperty(
      '--sonner-toast-bg',
      darkMode ? '#1F2937' : '#FFFFFF'
    );
    document.documentElement.style.setProperty(
      '--sonner-toast-color',
      darkMode ? '#F9FAFB' : '#1F2937'
    );
    document.documentElement.style.setProperty(
      '--sonner-toast-border',
      darkMode ? '#374151' : '#E5E7EB'
    );
  }, [darkMode]);

  return null; // This component doesn't render anything
};

export default ToasterThemeSync;
